import React from 'react';
import SettingsPage from './SettingsPage';

export default function SettingsRoute() {
  return <SettingsPage />;
}


